import { Injectable } from '@angular/core';

import { UnitModel } from '../Models/UnitModel';
import { UnitConfigApiModel } from '../Models/UnitConfigApiModel';
import { SpaContext } from '../../../../Classes/spacontext';
import { VisibaApiHttp } from '../../../../Classes/visibaHttp.class';
import { UnitAboutApiModel } from '../Models/UnitAboutApiModel';
import { WebContentButtonApiModel } from '../Models/WebContentButtonApiModel';
import { IdentifierConflictsApiModel } from '../Models/IdentifierConflictsApiModel';
import { HttpParams, HttpClient } from '@angular/common/http';

@Injectable()
export class UnitService {
	readonly baseUri = '/api/Client/v2/units';

	constructor(private http: VisibaApiHttp, private spaContext: SpaContext, private angularHttp: HttpClient) {}

	public getTree(unitId: number = null) {
		if (unitId === null) unitId = this.spaContext.unitConfig.LicenceHolder.RootUnit;

		return this.http.getTyped<UnitModel>(`${this.baseUri}/${unitId}/tree` + unitId + '/tree');
	}

	public getConfig() {
		return this.http.getTyped<UnitConfigApiModel>(`${this.baseUri}/${this.spaContext.unitConfig.Unit.UnitId}/config/web`);
	}

	public getAbout() {
		return this.http.getTyped<UnitAboutApiModel>(`${this.baseUri}/${this.spaContext.unitConfig.Unit.UnitId}/about`);
	}

	public getText(aliases: Array<string>) {
		return this.http.getTyped<{ [alias: string]: string }>(`${this.baseUri}/${this.spaContext.unitConfig.Unit.UnitId}/texts`, true, {
			params: { aliases: aliases.join() },
		});
	}

	public getIdentifierConflicts(
		countryCode: string,
		nationalIdentityNumber?: string,
		phoneNumber?: string,
		excludeClientId?: number,
	) {
		let params = new HttpParams();
		params = params.append('countryCode', countryCode);
		if (nationalIdentityNumber) {
			params = params.append('nationalIdentityNumber', nationalIdentityNumber);
		}
		if (phoneNumber) {
			params = params.append('phoneNumber', phoneNumber);
		}
		if (excludeClientId) {
			params = params.append('excludeClientId', excludeClientId.toString());
		}

		return this.http.getTyped<IdentifierConflictsApiModel>(
			`${this.baseUri}/${this.spaContext.unitConfig.Unit.UnitId}/IdentifierConflicts`,
			null,
			{ params },
		);
	}
}
